import { ApiRequestError } from '../types/common';
import apiClient from './apiClient';

/** O que a verificação pública do atendimento mostra — sem dado de saúde. */
export interface VerificacaoDeAtendimento {
  codigo: string;
  trabalhador: { nome: string; cpf: string | null };
  empresa: string | null;
  clinica: string | null;
  tipoDeExame: string;
  dataDoExame: string;
  concluidoEm: string | null;
  medico: { nome: string; crm: string | null } | null;
  documentos: { aso: boolean; guia: boolean; prontuario: boolean };
}

interface Resposta {
  success: boolean;
  data?: VerificacaoDeAtendimento;
  message?: string;
}

const NAO_ENCONTRADO = 'Nenhum documento com este código de verificação. Confira se digitou o código como está impresso.';

export const verificacaoDeAtendimentoService = {
  async verificar(codigo: string): Promise<VerificacaoDeAtendimento> {
    let resposta: Resposta | undefined;
    try {
      resposta = (await apiClient.get(`/verificacao-de-atendimento/${encodeURIComponent(codigo)}`)) as Resposta | undefined;
    } catch (err: unknown) {
      if (err instanceof ApiRequestError && err.status === 404) throw new Error(NAO_ENCONTRADO);
      throw new Error('Não foi possível verificar agora. Tente de novo em instantes.');
    }
    if (!resposta?.data) throw new Error(NAO_ENCONTRADO);
    return resposta.data;
  },
};

export default verificacaoDeAtendimentoService;
